import { FilterInputProps } from '@/components/table/_fieldDefinitions/_base/FilterInputProps.ts';
import MultiSelectInput from '@/components/form/MultiSelectInput.tsx';
import { NestedTransportVariantFieldDefinitionDto } from '@/components/table/_fieldDefinitions/nestedTransportVariant/NestedTransportVariantFieldDefinitionDto.ts';
import Option from '@/components/form/types/Option.ts';

export const NestedTransportVariantFilterInputs = ({
  form,
  index,
  fieldDef,
}: FilterInputProps) => {
  let options: Option[] = [];
  if (fieldDef) {
    const transportField = fieldDef as NestedTransportVariantFieldDefinitionDto;
    options =
      transportField.options?.map((o) => ({
        value: o.id,
        label: o.label,
      })) ?? [];
  }
  return (
    <MultiSelectInput
      controlSize="toolbar"
      placeholder="Wpisz wartość"
      fieldPath={`filters.${index}.value`}
      control={form.control}
      options={options}
    />
  );
};
